import type { IdeaSource } from './types';

/** Ideenbuch 1–10: pasta and the classics. */
export const IDEAS_1: IdeaSource[] = [
  {
    id: 'bolognese',
    minutes: 45,
    tags: ['kids'],
    de: {
      title: 'Spaghetti Bolognese',
      ingredients: [
        '400 g Spaghetti',
        '400 g Rinderhackfleisch',
        '1 Zwiebel, fein gewürfelt',
        '1 Möhre, fein gerieben',
        '2 Knoblauchzehen',
        '1 Dose passierte Tomaten',
        '2 EL Tomatenmark',
        '1 TL Oregano',
        'Parmesan zum Bestreuen',
      ],
      steps: [
        'Hackfleisch in einem großen Topf krümelig anbraten.',
        'Zwiebel, Möhre und Knoblauch dazugeben und 5 Minuten mitbraten.',
        'Tomatenmark kurz mitrösten, dann passierte Tomaten und Oregano einrühren.',
        'Die Soße 25 Minuten leise köcheln lassen, mit Salz und Pfeffer abschmecken.',
        'Spaghetti nach Packung kochen und mit der Soße und Parmesan servieren.',
      ],
      kidsTip: 'Die Möhre fein reiben – dann sieht sie niemand.',
    },
    en: {
      title: 'Spaghetti bolognese',
      ingredients: [
        '400 g spaghetti',
        '400 g beef mince',
        '1 onion, finely diced',
        '1 carrot, finely grated',
        '2 cloves garlic',
        '1 can passata',
        '2 tbsp tomato puree',
        '1 tsp oregano',
        'Parmesan to sprinkle',
      ],
      steps: [
        'Brown the mince in a large pan until crumbly.',
        'Add the onion, carrot and garlic and fry for 5 minutes.',
        'Stir in the tomato puree briefly, then the passata and oregano.',
        'Simmer the sauce gently for 25 minutes and season with salt and pepper.',
        'Cook the spaghetti as the packet says and serve with the sauce and Parmesan.',
      ],
      kidsTip: 'Grate the carrot finely – then nobody spots it.',
    },
  },
  {
    id: 'tomato-spaghetti',
    minutes: 20,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Spaghetti mit Tomatensoße',
      ingredients: [
        '400 g Spaghetti',
        '1 Zwiebel, gewürfelt',
        '1 Knoblauchzehe',
        '1 Dose gehackte Tomaten',
        '1 TL Zucker',
        '2 EL Olivenöl',
        'Basilikum',
        'Parmesan zum Bestreuen',
      ],
      steps: [
        'Spaghetti nach Packung kochen.',
        'Zwiebel und Knoblauch im Olivenöl glasig dünsten.',
        'Tomaten und Zucker dazugeben und 10 Minuten köcheln lassen.',
        'Mit Salz und Pfeffer abschmecken, Basilikum zupfen und mit den Spaghetti mischen.',
      ],
      kidsTip: 'Soße pürieren, wenn Stückchen nicht gut ankommen.',
    },
    en: {
      title: 'Spaghetti with tomato sauce',
      ingredients: [
        '400 g spaghetti',
        '1 onion, diced',
        '1 clove garlic',
        '1 can chopped tomatoes',
        '1 tsp sugar',
        '2 tbsp olive oil',
        'Basil',
        'Parmesan to sprinkle',
      ],
      steps: [
        'Cook the spaghetti as the packet says.',
        'Soften the onion and garlic in the olive oil.',
        'Add the tomatoes and sugar and simmer for 10 minutes.',
        'Season with salt and pepper, tear in the basil and toss with the spaghetti.',
      ],
      kidsTip: 'Blend the sauce if lumps are not popular.',
    },
  },
  {
    id: 'broccoli-bake',
    minutes: 45,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Nudelauflauf mit Brokkoli',
      ingredients: [
        '400 g Penne',
        '1 Brokkoli',
        '200 g Sahne',
        '200 ml Milch',
        '2 Eier',
        '200 g geriebener Käse',
        '1 Prise Muskat',
      ],
      steps: [
        'Ofen auf 200 °C vorheizen.',
        'Penne 4 Minuten kürzer als auf der Packung kochen, Brokkoliröschen die letzten 3 Minuten mitkochen.',
        'Sahne, Milch und Eier verquirlen, mit Salz, Pfeffer und Muskat würzen.',
        'Nudeln und Brokkoli in eine Auflaufform geben, Eiermilch darübergießen und mit Käse bestreuen.',
        '25 Minuten backen, bis der Käse goldbraun ist.',
      ],
      kidsTip: 'Brokkoli klein schneiden, dann versteckt er sich zwischen den Nudeln.',
    },
    en: {
      title: 'Pasta bake with broccoli',
      ingredients: [
        '400 g penne',
        '1 broccoli',
        '200 g cream',
        '200 ml milk',
        '2 eggs',
        '200 g grated cheese',
        '1 pinch nutmeg',
      ],
      steps: [
        'Heat the oven to 200 °C.',
        'Cook the penne 4 minutes less than the packet says, adding the broccoli florets for the last 3 minutes.',
        'Whisk the cream, milk and eggs and season with salt, pepper and nutmeg.',
        'Put the pasta and broccoli in a baking dish, pour over the egg mixture and top with cheese.',
        'Bake for 25 minutes until the cheese is golden.',
      ],
      kidsTip: 'Cut the broccoli small so it hides between the pasta.',
    },
  },
  {
    id: 'lasagne',
    minutes: 90,
    tags: ['kids'],
    de: {
      title: 'Lasagne',
      ingredients: [
        '12 Lasagneplatten',
        '500 g Hackfleisch',
        '1 Zwiebel, gewürfelt',
        '2 Dosen passierte Tomaten',
        '2 EL Tomatenmark',
        '50 g Butter',
        '50 g Mehl',
        '600 ml Milch',
        '150 g geriebener Käse',
      ],
      steps: [
        'Hackfleisch mit der Zwiebel anbraten, Tomatenmark und passierte Tomaten einrühren und 15 Minuten köcheln lassen.',
        'Für die helle Soße Butter schmelzen, Mehl einrühren, nach und nach Milch dazugießen und 5 Minuten köcheln lassen.',
        'Ofen auf 180 °C vorheizen.',
        'In einer Form abwechselnd Fleischsoße, Platten und helle Soße schichten, mit heller Soße und Käse enden.',
        '40 Minuten backen und vor dem Schneiden 10 Minuten ruhen lassen.',
      ],
      kidsTip: 'Am Vortag schichten – dann geht es am Abend schnell.',
    },
    en: {
      title: 'Lasagne',
      ingredients: [
        '12 lasagne sheets',
        '500 g mince',
        '1 onion, diced',
        '2 cans passata',
        '2 tbsp tomato puree',
        '50 g butter',
        '50 g flour',
        '600 ml milk',
        '150 g grated cheese',
      ],
      steps: [
        'Brown the mince with the onion, stir in the tomato puree and passata and simmer for 15 minutes.',
        'For the white sauce melt the butter, stir in the flour, add the milk bit by bit and simmer for 5 minutes.',
        'Heat the oven to 180 °C.',
        'Layer meat sauce, sheets and white sauce in a dish, finishing with white sauce and cheese.',
        'Bake for 40 minutes and let it rest for 10 minutes before cutting.',
      ],
      kidsTip: 'Layer it the day before – then the evening is quick.',
    },
  },
  {
    id: 'kaesespaetzle',
    minutes: 30,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Käsespätzle mit Röstzwiebeln',
      ingredients: [
        '500 g Spätzle (Kühlregal)',
        '200 g geriebener Bergkäse',
        '2 Zwiebeln, in Ringen',
        '2 EL Butter',
        'Schnittlauch',
      ],
      steps: [
        'Zwiebelringe in 1 EL Butter 10 Minuten goldbraun braten und herausnehmen.',
        'Ofen auf 200 °C vorheizen.',
        'Spätzle in der restlichen Butter erwärmen und abwechselnd mit dem Käse in eine Form schichten.',
        '10 Minuten backen, bis der Käse schmilzt, mit Röstzwiebeln und Schnittlauch servieren.',
      ],
      kidsTip: 'Röstzwiebeln extra auf den Tisch stellen.',
    },
    en: {
      title: 'Cheese spaetzle with crispy onions',
      ingredients: [
        '500 g spaetzle (chilled)',
        '200 g grated mountain cheese',
        '2 onions, in rings',
        '2 tbsp butter',
        'Chives',
      ],
      steps: [
        'Fry the onion rings in 1 tbsp butter for 10 minutes until golden and set aside.',
        'Heat the oven to 200 °C.',
        'Warm the spaetzle in the rest of the butter and layer with the cheese in a dish.',
        'Bake for 10 minutes until the cheese melts and serve with the onions and chives.',
      ],
      kidsTip: 'Put the crispy onions on the table separately.',
    },
  },
  {
    id: 'pancakes',
    minutes: 25,
    tags: ['veggie', 'kids'],
    de: {
      title: 'Pfannkuchen herzhaft oder süß',
      ingredients: [
        '250 g Mehl',
        '500 ml Milch',
        '3 Eier',
        '1 Prise Salz',
        '2 EL Butter zum Braten',
        'Apfelmus oder geriebener Käse zum Füllen',
      ],
      steps: [
        'Mehl, Milch, Eier und Salz zu einem glatten Teig verrühren und 10 Minuten quellen lassen.',
        'Etwas Butter in einer Pfanne erhitzen und eine dünne Schicht Teig hineingeben.',
        'Von jeder Seite 2 Minuten goldbraun backen.',
        'Mit Apfelmus oder Käse füllen und einrollen.',
      ],
      kidsTip: 'Jeder füllt seinen Pfannkuchen selbst.',
    },
    en: {
      title: 'Pancakes, savoury or sweet',
      ingredients: [
        '250 g flour',
        '500 ml milk',
        '3 eggs',
        '1 pinch salt',
        '2 tbsp butter for frying',
        'Apple sauce or grated cheese for filling',
      ],
      steps: [
        'Whisk the flour, milk, eggs and salt into a smooth batter and let it rest for 10 minutes.',
        'Heat a little butter in a pan and pour in a thin layer of batter.',
        'Cook each side for 2 minutes until golden.',
        'Fill with apple sauce or cheese and roll up.',
      ],
      kidsTip: 'Everyone fills their own pancake.',
    },
  },
  {
    id: 'potato-soup',
    minutes: 40,
    tags: ['veggie'],
    de: {
      title: 'Kartoffelsuppe',
      ingredients: [
        '1 kg Kartoffeln',
        '2 Möhren',
        '1 Stange Lauch',
        '1 Zwiebel',
        '1 l Gemüsebrühe',
        '100 g Sahne',
        '1 Prise Majoran',
        'Petersilie',
      ],
      steps: [
        'Kartoffeln, Möhren, Lauch und Zwiebel schälen bzw. putzen und klein schneiden.',
        'Alles in einem Topf kurz andünsten und mit der Brühe ablöschen.',
        '20 Minuten köcheln lassen, bis die Kartoffeln weich sind.',
        'Die Hälfte pürieren, Sahne und Majoran einrühren, mit Salz und Pfeffer abschmecken.',
        'Mit Petersilie bestreut servieren.',
      ],
      kidsTip: 'Wer mag, bekommt Würstchen-Scheiben hinein.',
    },
    en: {
      title: 'Potato soup',
      ingredients: [
        '1 kg potatoes',
        '2 carrots',
        '1 leek',
        '1 onion',
        '1 l vegetable stock',
        '100 g cream',
        '1 pinch marjoram',
        'Parsley',
      ],
      steps: [
        'Peel or trim the potatoes, carrots, leek and onion and chop them small.',
        'Soften everything briefly in a pan and pour in the stock.',
        'Simmer for 20 minutes until the potatoes are soft.',
        'Blend half of it, stir in the cream and marjoram and season with salt and pepper.',
        'Serve sprinkled with parsley.',
      ],
      kidsTip: 'Sausage slices for those who like them.',
    },
  },
  {
    id: 'lentil-curry',
    minutes: 35,
    tags: ['veggie'],
    de: {
      title: 'Linsencurry mit Reis',
      ingredients: [
        '250 g rote Linsen',
        '250 g Reis',
        '1 Zwiebel, gewürfelt',
        '1 Stück Ingwer',
        '2 TL Currypulver',
        '1 Dose Kokosmilch',
        '1 Dose gehackte Tomaten',
        '500 ml Gemüsebrühe',
        'Koriander oder Petersilie',
      ],
      steps: [
        'Reis nach Packung kochen.',
        'Zwiebel und geriebenen Ingwer andünsten, Currypulver kurz mitrösten.',
        'Linsen, Tomaten, Kokosmilch und Brühe dazugeben.',
        '20 Minuten köcheln lassen, bis die Linsen weich sind, mit Salz abschmecken.',
        'Mit Reis und Kräutern servieren.',
      ],
      kidsTip: 'Mildes Currypulver nehmen, Chili kommt erst am Tisch dazu.',
    },
    en: {
      title: 'Lentil curry with rice',
      ingredients: [
        '250 g red lentils',
        '250 g rice',
        '1 onion, diced',
        '1 piece ginger',
        '2 tsp curry powder',
        '1 can coconut milk',
        '1 can chopped tomatoes',
        '500 ml vegetable stock',
        'Coriander or parsley',
      ],
      steps: [
        'Cook the rice as the packet says.',
        'Soften the onion and grated ginger and toast the curry powder briefly.',
        'Add the lentils, tomatoes, coconut milk and stock.',
        'Simmer for 20 minutes until the lentils are soft and season with salt.',
        'Serve with the rice and herbs.',
      ],
      kidsTip: 'Use mild curry powder – chilli goes on at the table.',
    },
  },
  {
    id: 'chili-con-carne',
    minutes: 50,
    tags: [],
    de: {
      title: 'Chili con Carne',
      ingredients: [
        '500 g Rinderhackfleisch',
        '1 Zwiebel, gewürfelt',
        '1 Paprika, gewürfelt',
        '1 Dose Kidneybohnen',
        '1 Dose Mais',
        '1 Dose gehackte Tomaten',
        '2 EL Tomatenmark',
        '2 TL Kreuzkümmel',
        '1 TL Paprikapulver',
      ],
      steps: [
        'Hackfleisch krümelig anbraten, Zwiebel und Paprika 5 Minuten mitbraten.',
        'Tomatenmark, Kreuzkümmel und Paprikapulver kurz mitrösten.',
        'Tomaten, abgespülte Bohnen und Mais dazugeben.',
        '30 Minuten leise köcheln lassen und mit Salz und Pfeffer abschmecken.',
      ],
      kidsTip: 'Schmand und Brot dazu – das nimmt die Schärfe.',
    },
    en: {
      title: 'Chilli con carne',
      ingredients: [
        '500 g beef mince',
        '1 onion, diced',
        '1 pepper, diced',
        '1 can kidney beans',
        '1 can sweetcorn',
        '1 can chopped tomatoes',
        '2 tbsp tomato puree',
        '2 tsp cumin',
        '1 tsp paprika',
      ],
      steps: [
        'Brown the mince until crumbly and fry the onion and pepper with it for 5 minutes.',
        'Toast the tomato puree, cumin and paprika briefly.',
        'Add the tomatoes, rinsed beans and sweetcorn.',
        'Simmer gently for 30 minutes and season with salt and pepper.',
      ],
      kidsTip: 'Soured cream and bread on the side take the heat out.',
    },
  },
  {
    id: 'chili-sin-carne',
    minutes: 40,
    tags: ['veggie'],
    de: {
      title: 'Chili sin Carne',
      ingredients: [
        '1 Süßkartoffel, gewürfelt',
        '1 Zwiebel, gewürfelt',
        '1 Paprika, gewürfelt',
        '1 Dose Kidneybohnen',
        '1 Dose schwarze Bohnen',
        '1 Dose Mais',
        '1 Dose gehackte Tomaten',
        '2 TL Kreuzkümmel',
        '1 TL Paprikapulver',
      ],
      steps: [
        'Zwiebel, Paprika und Süßkartoffel 5 Minuten andünsten.',
        'Kreuzkümmel und Paprikapulver kurz mitrösten.',
        'Tomaten, abgespülte Bohnen und Mais dazugeben.',
        '25 Minuten köcheln lassen, bis die Süßkartoffel weich ist, mit Salz abschmecken.',
      ],
      kidsTip: 'Mit Tortilla-Chips zum Dippen wird es ein Fest.',
    },
    en: {
      title: 'Chilli sin carne',
      ingredients: [
        '1 sweet potato, diced',
        '1 onion, diced',
        '1 pepper, diced',
        '1 can kidney beans',
        '1 can black beans',
        '1 can sweetcorn',
        '1 can chopped tomatoes',
        '2 tsp cumin',
        '1 tsp paprika',
      ],
      steps: [
        'Soften the onion, pepper and sweet potato for 5 minutes.',
        'Toast the cumin and paprika briefly.',
        'Add the tomatoes, rinsed beans and sweetcorn.',
        'Simmer for 25 minutes until the sweet potato is soft and season with salt.',
      ],
      kidsTip: 'Tortilla chips for dipping turn it into a party.',
    },
  },
];
